import { render } from "./AddonItem.vue?vue&type=template&id=0b5b7406&scoped=true"
import script from "./AddonItem.vue?vue&type=script&lang=js"
export * from "./AddonItem.vue?vue&type=script&lang=js"

import "./AddonItem.vue?vue&type=style&index=0&id=0b5b7406&scoped=true&lang=css"

import exportComponent from "/home/rosenfeldt/projects/rosenfeldt/public_html/webshop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b5b7406"]])

export default __exports__